import { useEffect } from 'react';

const useAutoScroll = ({
  selectedItem,
  itemRefs,
  containerRef,
  offset = 16,
  behavior = 'smooth',
}) => {
  useEffect(() => {
    if (
      selectedItem?._id &&
      itemRefs.current?.[selectedItem._id] &&
      containerRef.current
    ) {
      const container = containerRef.current;
      const item = itemRefs.current[selectedItem._id];

      const itemTop = item.offsetTop;
      const itemBottom = itemTop + item.offsetHeight;

      const containerTop = container.scrollTop;
      const containerBottom = containerTop + container.clientHeight;

      if (itemTop < containerTop) {
        container.scrollTo({ top: itemTop - offset, behavior });
      } else if (itemBottom > containerBottom) {
        container.scrollTo({
          top: itemBottom - container.clientHeight + offset,
          behavior,
        });
      }
    }
  }, [selectedItem, itemRefs, containerRef, offset, behavior]);
};

export default useAutoScroll;
